import { LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { HeadingNode } from '@lexical/rich-text';
import { ParagraphNode } from 'lexical';

export default [LinkNode, ListItemNode, ListNode, HeadingNode, ParagraphNode];
